const dateOrdinal = function(d) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export default function(value) {
  const date = new Date(value);
  const dateString = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  const dateIdx = dateString.indexOf(" ");
  return `${dateString.substr(0, dateIdx)}${dateOrdinal(
    date.getDate(),
  )}${dateString.substr(dateIdx)}`;
}
